<template>
	<div>
		<div class="productList" v-show="productDataList==true">
			<div class="content w600">
				<ul class="w-1000 cf absolute pl5">
					<li v-for="(item,index) in productData" v-show="index==current_pos || index==current_pos+1" class="fl">
						<a href="javascript:;">
							<h5 class="companyName ft14">{{item.corpName}}</h5>
							<img src="/static/img/index/fsws.png" v-show='item.softId==2' alt="放射管理系统"/>
							<img src="/static/img/index/zyqy.png" v-show='item.softId==1' alt="职业健康"/>
							<img src="/static/img/index/zyjt.png" v-show='item.softId==4' alt="职业健康集团版"/>
							<img src="/static/img/index/jkgw.png" v-show='item.softId==3' alt="健康顾问"/>
							<h6 class="productName">{{item.softName}}</h6>
							<p class="time">到期时间：{{item.edate | dayFormat}}</p>
							<button class="clickenter" @click="enterSoft(item.corpSoftId,item.softId)">点击进入</button>
						</a>
					</li>

				</ul>
			</div>
			<span class="icon icon-left" v-show="productData.length>2 && current_pos>0" @click="left"></span>
			<span class="icon icon-right" v-show="productData.length>2 && current_pos<productData.length-2" @click="right"></span>

		</div>

		<div class="productList" v-show="productNodata==true">
			<a href="" class="imglink">
				<img src="/static/img/userCenter/img01.png"/>
				<p class="btn"></p>
				<!--<button class="btn"></button>-->
			</a>
		</div>
		<!-- 单点登录需要渲染的模板 -->
		<div v-html="jumphtml">

		</div>
		<el-dialog
			title="提示"
			:visible.sync="datedTips" width='30%' top='25vh'>
			<div class="dialog-content">
				<div class="pb20 relative text-center danger">
					{{datedTips_content}}
				</div>

			</div>
			<span slot="footer" class="dialog-footer">
			    <el-button @click="datedTips = false">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import { Loading } from 'element-ui';
	export default{
		name:'product-list',
		/*props:{
			productData:{
				type:Array
			}
		},*/
		data(){
			return{
				jumphtml:'',
				current_pos:0,
				productData:[],
				loadingInstance:null,//等待加载
				productDataList:false,
				productNodata:false,
				showEnterSoft:false,
				datedTips:false,//过期软件提示
				datedTips_content:'',
			}
		},
		mounted(){
			//请求软件list时调用
			// this.loadingInstance = Loading.service(
			// 										{  lock: true,
			// 						          		   text: '请稍候...',
			// 						                   spinner: 'el-icon-loading',
			// 						                   background: 'rgba(0, 0, 0, 0.7)',
			// 						                   target:'.content'
			// 						               });
			this.getSoftData()
		},
		//数据更新时跳转
		updated(){
			//this.getSoftData()
			if(this.showEnterSoft==true && document.querySelector('#cassubmit')!=null){
				document.forms['cassubmit'].submit();
				this.showEnterSoft=false;
			}

		},
		methods:{
			left(){

				this.current_pos-=2
			},
			right(){
				//this.move=-300;
				this.current_pos+=2
				//console.log(this.current_pos)

			},
			enterSoft(id,softId){
				let _this=this;
				let url;
				if(softId!=4){
					url="/uc/soft/casLogin?corpSoftId="+id
				}
				if(softId==4){
					url='/uc/soft/casLogin/supervisebloc?corpSoftId='+id
				}
				this.$ajax.get(url).then((res)=>{
	    				if(res.state.value==0){
	    					let index=res.content.indexOf('T')+2
	    					let str1=res.content.slice(0,index)
	    					let str2=res.content.slice(index)
	    					str1=str1+` target="_blank"`;
	    					res.content=str1+str2;
	    					//console.log(res.content)
							_this.jumphtml=res.content
							this.showEnterSoft=true
						}
						if(res.state.value==1){
							this.datedTips=true
							this.datedTips_content=res.content
						}

				}).catch((err)=>{

				})
			},
			//获得软件列表
			getSoftData(){
				let url='/uc/soft/list';
				this.$ajax.get(url).then((res) => {
					if(res.state.value==0){
						this.productData=res.result;
						if(this.productData.length>0){
							this.productDataList=true;
						}
						else{
							this.productNodata=true;
						}
						this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
						  //this.loadingInstance.close();
						});
					}
		        })
		        .catch((err) => {
		            console.log(err);
		        });
			},

		}
	}
</script>
<style >
.w600{width: 600px;}
.w-1000{width:1000%;}
.absolute{position: absolute;}
</style>



// WEBPACK FOOTER //
// src/components/productList/index.vue